document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('bespoke-cocktail-modal');
  const modalImg = document.getElementById('modal-image');
  const modalTitle = document.getElementById('modal-title');
  const modalDesc = document.getElementById('modal-desc');
  const closeBtn = document.querySelector('.bespoke-cocktails__close');
  const items = document.querySelectorAll('.bespoke-cocktails__item');

  function openModal(item) {
    const imgSrc = item.getAttribute('data-image');
    const title = item.getAttribute('data-title');
    const desc = item.getAttribute('data-desc');

    modalImg.src = imgSrc;
    modalTitle.textContent = title;
    modalDesc.innerHTML = desc; // Use innerHTML for rich text

    modal.classList.add('open');
    document.body.style.overflow = 'hidden'; // Prevent scrolling
  }

  function closeModal() {
    modal.classList.remove('open');
    document.body.style.overflow = ''; // Restore scrolling
    // Clear content after animation
    setTimeout(() => {
        modalImg.src = '';
        modalTitle.textContent = '';
        modalDesc.innerHTML = '';
    }, 300);
  }

  items.forEach(item => {
    item.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent default link behavior if any
      openModal(this);
    });
  });

  closeBtn.addEventListener('click', closeModal);

  // Close when clicking outside content
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) {
      closeModal();
    }
  });
});
